import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";
require("slim-select/dist/slimselect.min.css");

export default class extends Controller {
  static targets = [
    "template",
    "product",
    "items",
    "table"
  ];

  connect() {
    this.product = null;
  }

  addTableRow(event) {
    event.preventDefault();
    const selectedOptions = Array.from(this.productTarget.selectedOptions);
    selectedOptions.forEach(option => {
      const productId = option.value;
      if (productId) {
        this.getProduct(productId);
      }
    });
  }

  get productSelectController() {
    return this.application.getControllerForElementAndIdentifier(
      this.element,
      "product-select"
    );
  }

  addAssociation() {
    const content = this.templateTarget.innerHTML.replace(
      /TEMPLATE_RECORD/g,
      this.itemsTarget.querySelectorAll(".nested-fields").length
    );
    this.templateTarget.insertAdjacentHTML("beforebegin", content);
    this.addFieldValues();
    this.showTable();
  }

  addFieldValues() {
    const items = this.itemsTarget.querySelectorAll(".nested-fields");
    const item = items[items.length - 1];

    if (!item) {
      console.error("Failed to find the newly added item.");
      return;
    }

    const productIdInput = item.querySelector("input[name*='product_id']");
    const productNameInput = item.querySelector("input[name*='product_name']");

    if (productIdInput) productIdInput.value = this.product.id;
    if (productNameInput) productNameInput.value = this.product.name;
  }

  removeAssociation(event) {
    event.preventDefault();
    let item = event.target.closest(".nested-fields");
    item.querySelector("input[name*='_destroy']").value = 1;
    item.style.display = "none";
    this.hideTableIfEmpty();
  }

  getProduct(id) {
    Rails.ajax({
      type: "GET",
      url: `/featured_products/${id}.json`,
      success: (data, status, xhr) => {
        this.product = data;
        this.addAssociation();
      },
      error: (xhr, status, error) => {
        console.error("Product not found or not ecommerce-featured.");
        alert("The selected product is not available or not ecommerce-featured.");
      },
    });
  }

  showTable() {
    this.tableTarget.classList.remove("d-none");
  }

  hideTableIfEmpty() {
    if (this.itemsTarget.querySelectorAll(".nested-fields").length === 0) {
      this.tableTarget.classList.add("d-none");
    }
  }
}
